var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('iframe',{attrs:{"src":_vm.url,"id":"scanner","frameborder":"0","scrolling":"auto","allow":"camera"}})])}
var staticRenderFns = []

export { render, staticRenderFns }